export default __webpack_public_path__ + "static/media/tikka.54e42e67.jpg";